import { fetchPublicEvents } from "@jambushrushti/services/publicEvents";
import { fetchPublicBlogs } from "@jambushrushti/services/publicBlogs";
import { fetchPublicTelecasts } from "@jambushrushti/services/publicTelecasts";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@jambushrushti/integrations/supabase/client";
import { fetchPublicGallery } from "@jambushrushti/services/publicGallery";
import { fetchPublicGuruvani } from "@jambushrushti/services/publicGuruvani";

// Books Hook
export function useBooksFromDB() {
  return useQuery({
    queryKey: ["books-public"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("books")
        .select("*")
        .eq("is_published", true)
        .order("created_at", { ascending: false });

      if (error) {
        throw error;
      }

      return data || [];
    },
  });
}

// Guruvani Hook
export function useGuruvaniFromDB() {
  return useQuery({
    queryKey: ["guruvani-public"],
    queryFn: ({ signal }) => fetchPublicGuruvani(signal),
  });
}

// Articles Hook
export function useArticlesFromDB() {
  return useQuery({
    queryKey: ["articles-public"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("articles")
        .select("*")
        .eq("is_published", true)
        .order("created_at", { ascending: false });

      if (error) {
        throw error;
      }

      return data || [];
    },
  });
}

// Blogs Hook
export function useBlogsFromDB() {
  return useQuery({
    queryKey: ["blogs-public"],
    queryFn: ({ signal }) => fetchPublicBlogs(signal),
  });
}

// Events Hook
export function useEventsFromDB() {
  return useQuery({
    queryKey: ["events-public"],
    queryFn: ({ signal }) => fetchPublicEvents(signal),
  });
}

// Gallery Hook
export function useGalleryFromDB() {
  return useQuery({
    queryKey: ["gallery-public"],
    queryFn: ({ signal }) => fetchPublicGallery(signal),
  });
}

// Live Telecasts Hook
export function useLiveTelecastsFromDB() {
  return useQuery({
    queryKey: ["live-telecasts-public"],
    queryFn: ({ signal }) => fetchPublicTelecasts(signal),
  });
}
